export default "__VITE_ASSET__DhAp61Lf__";